<template>
  <ItemMobile1 v-if="$store.getters['merchant/theme'].details_template === 1"/>
  <ItemMobile2 v-else-if="$store.getters['merchant/theme'].details_template === 2"/>
  <span v-else></span>
</template>

<script>
import ItemMobile1 from "./templates/ItemMobile1";
import ItemMobile2 from "./templates/ItemMobile2";

export default {
		name: "ItemMobile",
		components: { ItemMobile2, ItemMobile1 }
	}
</script>
